import makeRequest from 'api/makeRequest';
import environment from 'environment';
import * as shopifyCustomerApi from './customers/shopify';
import * as commonCustomerApi from './customers';
import * as shopifyOrdersApi from './orders/shopify';
import * as commonOrdersApi from './orders';

export const fetchDecisionTrees = async (params) => {
  const { simplrAccountId, brand } = params;
  const url = `${environment.tools.DECISION_FLOW_BASE_URL}/specialist-portal/all-by-tag/account/${simplrAccountId}/brand/${brand}`;

  return await makeRequest(url);
};

export const fetchDecisionTreesAndLogicFlows = async (params) => {
  const { simplrAccountId, brand } = params;
  const url = `${environment.tools.DECISION_FLOW_BASE_URL}/specialist-portal/account/${simplrAccountId}/brand/${brand}?groupBy=tag&channel=HUMAN_CLOUD`;

  return await makeRequest(url);
};

export const fetchCustomInfoWidget = async (widgetId) => {
  const url = `${environment.tools.CUSTOM_INFO_WIDGETS_URL}/${widgetId}`;

  return await makeRequest(url);
};

export const patchOrderTags = async ({ simplrAccountId, orderId, shopName, tags, orderingSystem }) => {
  switch (orderingSystem) {
    case 'shopify':
      return await shopifyOrdersApi.patchOrderTags({ simplrAccountId, orderId, shopName, tags });
    case 'common':
    default:
      return await commonOrdersApi.patchOrderTags({ simplrAccountId, orderId, shopName, tags });
  }
};

export const patchCustomerNotes = async ({ simplrAccountId, customerId, shopName, note, orderingSystem }) => {
  switch (orderingSystem) {
    case 'shopify':
      return await shopifyCustomerApi.patchCustomerNotes({ simplrAccountId, customerId, shopName, note });
    case 'common':
    default:
      return await commonCustomerApi.patchCustomerNotes({ simplrAccountId, customerId, shopName, note });
  }
};

export const fetchCustomerInfo = async (customerId, simplrAccountId, shopName, orderingSystem) => {
  switch (orderingSystem) {
    case 'shopify':
      return await shopifyCustomerApi.fetchCustomerInfo(customerId, simplrAccountId, shopName);
    case 'common':
    default:
      return await commonCustomerApi.fetchCustomerInfo(customerId, simplrAccountId, shopName);
  }
};
